module.exports = __webpack_public_path__ + "img/news_gongshi.577d4455.svg";